<template>
  <div class="home-content">
    <h-head v-if="!isMaxScreen"></h-head>
    <Head v-if="isMaxScreen" ref="head" :backFn="back"></Head>
    <div :class="[isMaxScreen ? 'pc_privacyPolicy-container' : 'privacyPolicy-container']">
      <h1>{{ privacyPolicy.title }}</h1>

      <div v-for="(section, index) in privacyPolicy.sections" :key="index">
        <h2 class="h2">{{ section.title }}</h2>
        <div v-html="section.content" class="content"></div>

        <div v-if="section.subsections">
          <div v-for="(subsection, subIndex) in section.subsections" :key="subIndex">
            <h3 class="h3">{{ subsection.title }}</h3>
            <div v-html="subsection.content" class="content"></div>
          </div>
        </div>
      </div>

      <!-- <div class="content" v-html="privacyPolicy.footer"></div> -->
    </div>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import hHead from '@/components/layout/head.vue';
import Head from '../../components/head';
import Bottom from '../../components/bottom';
import { enData } from './enData.js';
import { esData } from './esData.js';
import { frData } from './frData.js';
import { daData } from './daData.js';
import { deData } from './deData.js';
import { fiData } from './fiData.js';
import { itData } from './itData.js';
import { nlData } from './nlData.js';
import { plData } from './plData.js';
import { svData } from './svData.js';
import { lang } from '@/locales';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      lang
    };
  },
  components: {
    hHead,
    Head,
    Bottom
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    }),
    privacyPolicy() {
      // 根据当前语言返回对应的数据
      const languageData = {
        en: enData,
        es: esData,
        fr: frData,
        da: daData,
        de: deData,
        fi: fiData,
        it: itData,
        nl: nlData,
        pl: plData,
        sv: svData
      };

      return languageData[this.lang] || enData; // 默认返回英文
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
      // this.$router.push({ name: 'Home' });
    }
  }
};
</script>

<style scoped lang="less">
@media (min-width: 981px) {
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: 'PingFang SC';
    .pc_privacyPolicy-container {
      padding: 160px 0 120px;
      width: 1200px;
      margin: 0 auto;

      .content {
        font-size: 18px;
      }

      h1 {
        font-size: 32px;
        text-align: center;
        margin-top: 0;
      }

      .h2 {
        font-size: 28px;
      }

      .h3 {
        font-size: 26px;
      }

      table {
        margin: 0 10px;
      }
    }
  }


  // 然后在 CSS 文件中添加
  .privacy-policy-list {
    list-style-type: disc;
    padding-left: 20px;
  }

  .privacy-policy-item {
    margin-bottom: 8px;
    color: #333;
    line-height: 1.5;
  }
}
@media (max-width: 980px) {
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: 'PingFang SC';
    .privacyPolicy-container {
      padding: 148px 30px 48px;

      h1 {
        font-size: 36px;
        text-align: center;
        margin-top: 0;
        margin-bottom: 50px;
      }

      .content {
        overflow-x: scroll;
      }
    }
  }
}
</style>
